import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-text-icon',
    templateUrl: './text-icon.component.html',
    styleUrls: ['./text-icon.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class TextIconComponent implements OnInit {
    @Input() icon: string;
    @Input() tooltip: string;
    @Output() clickEvent: EventEmitter<any> = new EventEmitter<any>();

    constructor() {}

    ngOnInit(): void {
        this.icon = this.icon ? this.icon : 'info_outline';
    }

    onClick() {
        this.clickEvent.emit(true);
    }
}
